import { supabase } from '@/lib/supabase';

export const TRANSACTION_TYPES = [
  ['purchase_request', 'Purchase request'], ['purchase_order', 'Purchase order'], ['supplier_invoice', 'Supplier invoice'],
  ['subcontract_order', 'Subcontract order'], ['subcontract_payment', 'Subcontract payment'], ['variation', 'Variation'],
  ['timesheet', 'Timesheet'], ['expense', 'Expense'],
];
export const typeLabel = (t) => TRANSACTION_TYPES.find(([k]) => k === t)?.[1] || t;

export async function listMyApprovals() {
  const { data, error } = await supabase.from('v_my_approvals').select('*').order('requested_at', { ascending: false });
  if (error) throw error;
  return data;
}
export async function listRequests(organisationId, { status } = {}) {
  let q = supabase.from('approval_requests').select('*').eq('organisation_id', organisationId).order('requested_at', { ascending: false }).limit(200);
  if (status && status !== 'all') q = status === 'open' ? q.in('status', ['pending', 'escalated']) : q.eq('status', status);
  const { data, error } = await q;
  if (error) throw error;
  return data;
}
export async function getRequest(id) {
  const { data, error } = await supabase.from('approval_requests').select('*').eq('id', id).single();
  if (error) throw error;
  return data;
}
export async function listEvents(requestId) {
  const { data, error } = await supabase.from('approval_events').select('*').eq('request_id', requestId).order('id');
  if (error) throw error;
  return data;
}
export async function decide(requestId, decision, note, toUser) {
  const { data, error } = await supabase.rpc('decide_approval', { _request_id: requestId, _decision: decision, _note: note || null, _to_user: toUser || null });
  if (error) throw error;
  return data;
}
export async function cancel(requestId, note) {
  const { data, error } = await supabase.rpc('cancel_approval', { _request_id: requestId, _note: note || null });
  if (error) throw error;
  return data;
}

// Delegated authorities (owner writes; manager+ reads)
export async function listAuthorities(organisationId) {
  const { data, error } = await supabase.from('approval_authorities').select('*').eq('organisation_id', organisationId).order('created_at', { ascending: false });
  if (error) throw error;
  return data;
}
export async function createAuthority(row) {
  const { data, error } = await supabase.from('approval_authorities').insert(row).select().single();
  if (error) throw error;
  return data;
}
export async function setAuthorityActive(id, active) {
  const { data, error } = await supabase.from('approval_authorities').update({ active }).eq('id', id).select().single();
  if (error) throw error;
  return data;
}
export const memberLabel = (m) => m ? `${m.display_name || m.email || `${m.user_id.slice(0, 8)}…`} (${m.role})` : '—';
export async function listMembers(organisationId) {
  const dir = await supabase.from('v_organisation_member_directory').select('user_id, role, display_name, email').eq('organisation_id', organisationId).order('display_name');
  if (!dir.error) return dir.data;
  const { data, error } = await supabase.from('organisation_members').select('user_id, role').eq('organisation_id', organisationId);   // directory view not yet applied
  if (error) throw error;
  return data;
}
export async function listProjects(organisationId) {
  const { data, error } = await supabase.from('projects').select('id, project_code, name').neq('status', 'archived').eq('organisation_id', organisationId).order('project_code');
  if (error) throw error;
  return data;
}
export async function getSettings(organisationId) {
  const { data, error } = await supabase.from('organisation_settings').select('*').eq('organisation_id', organisationId).maybeSingle();
  if (error) throw error;
  return data;
}
export async function saveSettings(organisationId, patch) {
  const { data, error } = await supabase.from('organisation_settings').upsert({ organisation_id: organisationId, ...patch }).select().single();
  if (error) throw error;
  return data;
}
